// extracted by mini-css-extract-plugin
export default {"operatorDetails":"dt_mM","image":"dt_cS","ribbon":"dt_hS","contentRibbon":"dt_nv","operatorName":"dt_fs","details":"dt_bz","ratingAuthor":"dt_nw","reviewLink":"dt_nx"};